import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import Header from './components/Header'    
import Dashboard from './pages/Dashboard';
import Homepage from './pages/Homepage';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Register from './pages/Register'

import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css' 

import image from "./images/asylum_interior.jpg";
import image2 from "./images/woman.jpg";
import image3 from "./images/facade.jpg";

let backgrounds = [image, image2, image3];
let randBackground = backgrounds[Math.floor(Math.random() * backgrounds.length)];

// <div style={{backgroundImage: `url(${background})`}}></div>

function App() {
  return (
    <>
    <div
      style={{
        backgroundImage:
        `url(${randBackground})`,
        minHeight: "100vh",         
        // set minium height to the height of the viewport (for parallax scrolling purposes)

        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        
        
        // width: "100vw",
        // height: "100vh",
      }} >
      <Router>
        <div className='container'>
          {/* REMEMBER THAT THE CODE AFTER THE "RETURN" IS JSX, HERE'S HOW TO COMMENT IN JSX.
          Here's how we set up our routes for each of the pages. We are SETTING the paths, which 
          we'll use in the browser to determine which page to show. Example: http://localhost:5000/api/users/login
          Fascinating.*/}
          <Header />  
          {/* Put our header above the routes. Nothing goes in Routes unless its a Route tag. */}
          <Routes>      
            <Route path='/' element={<Dashboard/>} />   
            <Route path='/homepage' element={<Homepage/>} /> 
            <Route path='/welcome' element={<Welcome/>} />
            <Route path='/login' element={<Login/>} />
            <Route path='/register' element={<Register/>} />
          </Routes>
        </div>
      </Router>
      <ToastContainer />    
      {/* put toastContainer here. */}
      </div>
    </>
  );
}

export default App;